import { WEB_LINKS } from "../webLinks";
import { TranslationKeys } from "../../types/i18n";

export const arTranslations = {
  common: {
    continue: "طلب رمز التحقق",
    cancel: "إلغاء",
    done: "تم",
    back: "رجوع",
    next: "التالي",
    submit: "إرسال",
    loading: "جاري التحميل...",
    error: "خطأ",
    success: "نجح",
    retry: "إعادة المحاولة",
    save: "حفظ",
    edit: "تعديل",
    delete: "حذف",
    confirm: "تأكيد",
    yes: "نعم",
    no: "لا",
    search: "بحث",
    verify: "تحقق",
    ok: "موافق",
    close: "إغلاق",
    welcome: "مرحباً",
    noContentAvailable: "لا يوجد محتوى متاح.",
    home: "الرئيسية",
    scrollToBottomToAccept: "انتقل إلى الأسفل للموافقة",
    open: "فتح",
    saveShare: "حفظ/مشاركة",
    downloadSuccessTitle: "تم التنزيل بنجاح",
    monthJanuary: "يناير",
    monthFebruary: "فبراير",
    monthMarch: "مارس",
    monthApril: "أبريل",
    monthMay: "مايو",
    monthJune: "يونيو",
    monthJuly: "يوليو",
    monthAugust: "أغسطس",
    monthSeptember: "سبتمبر",
    monthOctober: "أكتوبر",
    monthNovember: "نوفمبر",
    monthDecember: "ديسمبر",
  },
  accessibility: {
    carouselPrevious: "الصورة السابقة",
    carouselNext: "الصورة التالية",
  },
  auth: {
    login: "تسجيل الدخول",
    signIn: "تسجيل الدخول",
    loginSubtitle: "اختر طريقة تسجيل الدخول المفضلة لديك",
    loginWithEmail: "تسجيل الدخول بالبريد الإلكتروني",
    continueWithEmail: "المتابعة بالبريد الإلكتروني",
    welcomeBack: "مرحباً بعودتك!",
    loginToAccessProperties: "سجل الدخول للوصول إلى ممتلكاتك",
    signInToAccessProperties: "قم بتسجيل الدخول للوصول إلى ممتلكاتك",
    loginDescription: "يرجى إدخال بريدك الإلكتروني وكلمة المرور",
    newOnBloom: "جديد في بلوم؟",
    register: "إنشاء حساب",
    logout: "تسجيل الخروج",
    email: "البريد الإلكتروني",
    emailId: "البريد الإلكتروني",
    password: "كلمة المرور",
    forgotPassword: "نسيت كلمة المرور",
    forgotPasswordDescription:
      "يرجى إدخال بريدك الإلكتروني المسجل. سنرسل رمز التحقق لإعادة تعيين كلمة المرور عبر البريد الإلكتروني",
    sendResetLink: "طلب رمز التحقق",
    passwordSentTitle: "لقد أرسلنا كلمة المرور إلى بريدك الإلكتروني",
    passwordSentDescription:
      "قم بتسجيل الدخول بكلمة المرور المرسلة إلى {email} وإعادة تعيين كلمة المرور",
    backToLogin: "العودة لتسجيل الدخول",
    enterEmailId: "أدخل البريد الإلكتروني",
    enterPassword: "أدخل كلمة المرور",
    emailRequired: "البريد الإلكتروني مطلوب",
    passwordRequired: "كلمة المرور مطلوبة",
    invalidEmail: "يرجى إدخال عنوان بريد إلكتروني صحيح",
    loginError:
      "البريد الإلكتروني أو كلمة المرور غير صحيحة. يرجى المحاولة مرة أخرى.",
    sessionExpired: "انتهت صلاحية جلستك.",
    deviceIdMismatch:
      "تم تسجيل الدخول من جهاز آخر. يرجى تسجيل الدخول مرة أخرى.",
    createAccount: "إنشاء حساب",
    alreadyHaveAccount: "لديك حساب بالفعل؟",
    dontHaveAccount: "ليس لديك حساب؟",
    loginWithUAEPass: "تسجيل الدخول بالهوية الرقمية",
    registerWithUAEPass: "التسجيل بالهوية الرقمية",
    registerWithEmiratesID: "التسجيل بالهوية الإماراتية",
    registerWithPassport: "التسجيل بجواز السفر",
    uaePassLogin: "تسجيل الدخول بالهوية الرقمية",
    emiratesIdRegistration: "التسجيل بالهوية الإماراتية",
    passportRegistration: "التسجيل بجواز السفر",
    continueWithUAEPass: "المتابعة بالهوية الرقمية الإماراتية",
    continueAsGuest: "المتابعة كزائر",
    continueWithEmiratesID: "المتابعة بالهوية الإماراتية",
    continueWithPassport: "المتابعة بجواز السفر",
    loginWithEmiratesIDButton: "تسجيل الدخول بالهوية الإماراتية",
    verifyIdentity: "تحقق من هويتك",
    mobileVerificationSent:
      "لقد أرسلنا رمز تحقق مكون من 4 أرقام إلى رقم هاتفك المحمول المسجل",
    emailVerificationSent:
      "لقد أرسلنا رمز تحقق مكون من 4 أرقام إلى بريدك الإلكتروني المسجل",
    didntReceiveCode: "لم تستلم الرمز؟",
    noAccessToPhone: "ليس لديك وصول إلى رقم الهاتف هذا.",
    raiseSupportTicket: "ارفع تذكرة دعم",
    verifyAndContinue: "تحقق ومتابعة",
    resendOTP: "إعادة إرسال رمز التحقق",
    resendOTPTimer: "إعادة إرسال رمز التحقق خلال {resendTimer}",
    emiratesId: "الهوية الإماراتية",
    emiratesIdInputPlaceholder: "xxxx - xxxx - xxxx",
    invalidEmiratesId: "يرجى إدخال هوية إماراتية صالحة.",
    continue: "متابعة",

    verify: "تحقق",
    emiratesIdPlaceholder: "784 - أدخل الهوية الإماراتية",
    registrationSuccessful: "تم التسجيل بنجاح!",
    registrationWasSuccessful: "تم تسجيلك بنجاح!",
    setupPasswordToComplete:
      "قم بإعداد كلمة المرور لإكمال الإعداد والوصول إلى عقاراتك",
    almostThere:
      "أوشكت على الانتهاء، قم بتسجيل الدخول عبر الهوية الرقمية للوصول إلى عقاراتك",
    registrationRequestSubmitted: "تم إرسال طلب التسجيل بنجاح!",
    weWillConfirmDetails: "سنؤكد التفاصيل ونخطرك بمجرد أن يصبح الوصول جاهزاً.",
    registrationAttemptFailed: "فشلت محاولة التسجيل الخاصة بك",
    tryRegisteringAgain: "يرجى المحاولة مرة أخرى أو الاتصال بدعم العملاء.",
    setupPasscode: "إعداد رمز المرور",
    uaePassSuccess: "تم التحقق من الهوية الرقمية بنجاح",
    uaePassError: "خطأ في التحقق من الهوية الرقمية",
    newPassword: "كلمة مرور جديدة",
    changePassword: "تغيير كلمة المرور",
    setNewPassword: "قم بتعيين كلمة مرور جديدة",
    enterNewPassword: "أدخل كلمة المرور الجديدة",
    enterNewPasswordTitle: "أدخل كلمة مرور جديدة",
    pleaseEnterNewPassword: "يرجى إدخال كلمة مرور جديدة",
    enterCurrentPassword: "أدخل كلمة المرور الحالية",
    enterCurrentPasswordTitle: "أدخل كلمة المرور الحالية",
    pleaseEnterCurrentPassword: "يرجى إدخال كلمة المرور الحالية للمتابعة",
    confirmNewPassword: "تأكيد كلمة المرور الجديدة",
    passwordMatches: "كلمة المرور متطابقة",
    passwordChangedSuccessfully: "تم تغيير كلمة المرور",
    passwordSameAsCurrent:
      "لا يمكن أن تكون كلمة المرور الجديدة هي نفس كلمة المرور الحالية",
    changePasswordConfirmationTitle: "هل أنت متأكد أنك تريد تغيير كلمة المرور؟",
    changePasswordConfirmationMessage:
      "سيتم إرسال بريد إلكتروني إلى عنوانك المسجل لإعادة تعيين كلمة مرور حسابك.",
    passwordRuleCapital: "حرف كبير واحد",
    passwordRuleSmall: "حرف صغير واحد",
    passwordRuleNumber: "رقم واحد",
    passwordRuleSymbol: "رمز واحد",
    adhaUaePass: {
      processing: "جارٍ المعالجة",
      userCancelledLogin: "ألغى المستخدم تسجيل الدخول",
      somethingWentWrong:
        "حدث خطأ أثناء تسجيل الدخول، يرجى المحاولة مرة أخرى لاحقاً!",
      sop1: "أنت غير مؤهل للوصول إلى هذه الخدمة. إما أن حسابك غير مُرقّى أو لديك حساب زائر. يرجى التواصل مع شركاء بلووم للوصول إلى الخدمات.",
      userNotRegistered:
        "هذه الخدمة مخصصة للمستخدمين المسجلين فقط، يرجى التواصل مع بلووم أدهى للوصول إلى الخدمات.",
      missingCode:
        "تعذر إكمال تسجيل الدخول عبر الهوية الرقمية. يرجى المحاولة مرة أخرى.",
      errorInvalidSession:
        "حدث خطأ أثناء تسجيل الدخول، يرجى المحاولة مرة أخرى لاحقاً!",
      errorGeneric:
        "حدث خطأ أثناء تسجيل الدخول، يرجى المحاولة مرة أخرى لاحقاً!",
    },
  },
  otp: {
    verifyPhoneNumber: "تأكيد رقم الهاتف",
    verifyEmail: "تغيير بريد التواصل الإلكتروني",
    changePhoneNumber: "تغيير رقم الهاتف",
    changeCommunicationEmail: "تغيير بريد التواصل الإلكتروني",
    changeLoginEmail: "تغيير بريد تسجيل الدخول الإلكتروني",
    verifyPhoneDescription:
      "يساعدنا التحقق من رقم هاتفك على تأكيد هويتك ومنع الوصول غير المصرح به.",
    verifyEmailDescription:
      "يساعدنا التحقق من بريدك الإلكتروني على تأكيد هويتك ومنع الوصول غير المصرح به.",
    enterOTP: "يرجى إدخال رمز التحقق المرسل إلى {contact}",
    enterPhoneForOTP: "يرجى إدخال رقم هاتفك لتلقي رمز التحقق",
    enterEmailForOTP: "يرجى إدخال بريدك الإلكتروني لتلقي رمز التحقق",
    resendOTP: "إعادة إرسال رمز التحقق",
    resendOTPTimer: "إعادة إرسال رمز التحقق خلال {resendTimer}",
    otpSent: "تم إرسال رمز التحقق بنجاح",
    otpVerified: "تم التحقق من الرمز بنجاح",
    invalidOTP: "رمز التحقق غير صحيح",
    invalidOTPPleaseTryAgain: "رمز التحقق غير صحيح. يرجى المحاولة مرة أخرى.",
    otpExpired:
      "انتهت صلاحية رمز التحقق. اضغط على إعادة إرسال رمز التحقق للحصول على رمز جديد.",
    pasteOTP: "لصق رمز التحقق",
    requestOtp: "طلب رمز التحقق",
  },
  welcome: {
    welcomeTitle: "مرحباً بكم في تجربة عقارية متطورة",
    heroTitle: "عقارك ... ببساطة",
    heroSubtitle:
      "أدر عقاراتك في بلووم، تابع الدفعات، وابقَ على اطلاع دائم على تقدم الإنشاءات في مشاريعنا من خلال منصتنا الذكية.",
    downloadApp: "حمّل التطبيق للتسجيل",
    login: "تسجيل دخول",
    welcomeTo: "مرحباً بك في",
    appName: "بلوم القابضة",
    subtitle1: "كل ما تحتاجه لإدارة عقاراتك في مكان واحد",
    uaeCitizenResident: "مواطن/مقيم إماراتي",
    internationalUser: "مستخدم دولي",
    chooseYourPath: "أخبرنا من أنت للبدء",
    registerTitle: "إنشاء حساب",
    registerSubtitle: "أخبرنا من أنت للبدء",
    uaeRegistrationTitle: "مواطن/مقيم إماراتي إنشاء حساب",
    uaeRegistrationSubtitle:
      "للمتابعة، يرجى التسجيل باستخدام الهوية الرقمية أو الهوية الإماراتية لعرض تفاصيل عقارك.",
    internationalRegistrationTitle: "مستخدم دولي إنشاء حساب",
    internationalRegistrationSubtitle:
      "استخدم جواز سفرك للتسجيل وفتح الوصول إلى عقارك.",
    uaeMethodsTitle: "مواطن/مقيم إماراتي إنشاء حساب",
    uaeMethodsSubtitle:
      "للمتابعة، يرجى التسجيل باستخدام الهوية الرقمية أو الهوية الإماراتية لعرض تفاصيل عقارك.",
    registerWithUaePass: "إنشاء حساب بالهوية الرقمية",
    registerWithEmiratesId: "إنشاء حساب بالهوية الإماراتية",
    internationalMethodsTitle: "مستخدم دولي إنشاء حساب",
    internationalMethodsSubtitle:
      "استخدم جواز سفرك للتسجيل وفتح الوصول إلى عقارك.",
    registerWithPassport: "إنشاء حساب بجواز السفر",
    faqSupport: "الأسئلة الشائعة والدعم",
    or: "أو",
  },
  webHome: {
    featuresPill: "الميزات",
    featuresTitle: "حل متكامل لإدارة محفظتك العقارية",
    featuresSubtitle:
      "من متابعة العقارات إلى إدارة الدفعات، توفر منصتنا جميع الأدوات التي تحتاجها في مكان واحد بتجربة استخدام أنيقة وسهلة.",
    featuresPropertyManagementTitle: "إدارة العقارات",
    featuresPropertyManagementBody:
      "تابع عقاراتك، اطّلع على تقدّم الإنشاءات، وأدر محفظتك العقارية بكل سهولة.",
    featuresPaymentTrackingTitle: "متابعة الدفعات",
    featuresPaymentTrackingBody:
      "ابقَ على اطلاع بجميع الدفعات والرسوم والالتزامات المالية مع تنبيهات وإشعارات فورية.",
    featuresSecurePlatformTitle: "منصة آمنة",
    featuresSecurePlatformBody:
      "تحمي بياناتك باستخدام تقنيات تشفير وأمان متقدمة على مستوى المؤسسات.",
    mobilePill: "تجربة الهاتف المحمول",
    mobileTitle: "أدر عقاراتك في بلووم من أي مكان",
    mobileSubtitle:
      "تصميمنا المخصص للهاتف المحمول يضمن لك الوصول إلى معلومات عقاراتك ومتابعة الدفعات والحصول على التحديثات أينما كنت.",
    mobileBullet1: "تحديثات تقدم أعمال البناء في الوقت الفعلي",
    mobileBullet2: "تنبيهات وإشعارات فورية للدفعات",
    mobileBullet3: "تصفح المستندات بشكل آمن",
    mobileBullet4: "دعم فوري للعملاء",
    mobileCta: "حمّل التطبيق",
    mobileToast1Title: "تم تأكيد الدفع",
    mobileToast1Body: "تم استلام دفعتك بقيمة 110,000 درهم إماراتي",
    mobileToast2Title: "تحديث تقدم البناء",
    mobileToast2Body: "تم إنجاز 75% من عقارك A1-401 ضمن مشروع Bloom Central.",
    testimonialsPill: "آراء العملاء",
    testimonialsTitle: "موثوق بنا من قبل آلاف المستثمرين العقاريين",
    testimonialsSubtitle: "اطّلع على آراء عملائنا حول تجربتهم مع بلووم.",
    testimonialsCard1Body:
      '"لقد غيرت بلووم طريقة إدارتي لاستثماراتي العقارية. ميزة تتبع الدفعات وحدها وفرت لي الكثير من الوقت"',
    testimonialsCard1Name: "أحمد المنصوري",
    testimonialsCard1Role: "مستثمر عقاري",
    testimonialsCard2Body:
      '"تحديثات تقدم أعمال البناء تمنحني الراحة والطمئنينة. أعرف دائماً كيف تتطور أعمال البناء لمنزلي الجديد بالضبط."',
    testimonialsCard2Name: "سارة جونسون",
    testimonialsCard2Role: "مشتري لأول مرة",
    testimonialsCard3Body:
      '"عملائي يحبون الشفافية والتحديثات اللحظية. لقد جعل هذا عملي أسهل بكثير."',
    testimonialsCard3Name: "محمد حسن",
    testimonialsCard3Role: "وسيط عقاري",
    ctaTitle: "هل أنت مستعد للارتقاء بتجربتك العقارية؟",
    ctaSubtitle:
      "انضم إلى آلاف المستثمرين العقاريين الذين يثقون ببلووم لإدارة محفظتهم العقارية.",
    ctaButton: "تواصل مع فريق المبيعات",
    footerAbout:
      "بلووم القابضة هي شركة تطوير رائدة مقرها الإمارات العربية المتحدة، متخصصة في العقارات والتعليم والضيافة، ولديها مشاريع في جميع أنحاء الإمارات وعلى الصعيد الدولي. نركز على إنشاء مجتمعات متكاملة، وندير فنادق فاخرة ومدارس مرموقة، مع توسيع بصمتنا من خلال مشاريع جديدة مثل مابيل ماربيلا ريزيدنسز في إسبانيا.",
    footerProjectsHeading1: "مشاريعنا",
    footerProjectsItem1: "عقار - تأجير",
    footerProjectsItem2: "عقار - مبيعات",
    footerProjectsItem3: "الضي",
    footerProjectsItem4: "بلووم أرجان من روتانا",
    footerProjectsItem5: "سوهو سكوير",
    footerProjectsHeading2: "",
    footerProjectsItem6: "بلووم سنترال",
    footerProjectsItem7: "حدائق بلووم",
    footerProjectsItem8: "بلووم هايتس",
    footerProjectsItem9: "بلووم ليفينج - أبوظبي",
    footerProjectsItem10: "روتشستر، الولايات المتحدة الأمريكية",
    footerContactHeading: "اتصل بنا",
    footerContactPhone1: "80025666",
    footerContactPhone2: "(من خارج الإمارات) +97126969500",
    footerContactEmail: "customerservice@bloomholding.com",
    footerContactTwitter: "تويتر",
    footerContactFacebook: "فيسبوك",
    footerContactInstagram: "إنستغرام",
    footerContactLinkedIn: "لينكدإن",
    footerContactTikTok: "تيك توك",
    footerContactYouTube: "يوتيوب",
    footerContactTwitterUrl: WEB_LINKS.TWITTER,
    footerContactFacebookUrl: WEB_LINKS.FACEBOOK,
    footerContactInstagramUrl: WEB_LINKS.INSTAGRAM,
    footerContactLinkedInUrl: WEB_LINKS.LINKEDIN,
    footerContactTikTokUrl: WEB_LINKS.TIKTOK,
    footerContactYouTubeUrl: WEB_LINKS.YOUTUBE,
    documentAppName: "بلوم القابضة",
    documentDescription:
      "أدر عقاراتك في بلووم، تابع الدفعات، وابقَ على اطلاع دائم على تقدم الإنشاءات في مشاريعنا من خلال منصتنا الذكية.",
    documentHome: "استكشف عالم بلوم",
    documentWelcome: "مرحباً بكم في تجربة عقارية متطورة",
    documentProperties: "استكشف العقارات",
    documentProjectDetails: "تفاصيل المشروع",
    documentFaq: "الأسئلة الشائعة",
  },
  language: {
    changeLanguage: "تغيير اللغة",
  },
  profile: {
    faqCategories: "الفئات",
    faqSearchPlaceholder: "بحث",
    faqCantFind: "لديك أسئلة أخرى؟ فريقنا جاهز لمساعدتك",
    faqRaiseRequest: "ارسال طلب",
    popularQuestions: "الأسئلة الشائعة",
    faqEmptyTitle: "لا توجد أسئلة متاحة",
    faqEmptySubtitle: "يرجى التحقق مرة أخرى لاحقاً.",
    faqSearchNoResultsTitle: "لم يتم العثور على أسئلة شائعة.",
    faqSearchNoResultsSubtitle: "جرب البحث باستخدام كلمة رئيسية مختلفة.",
    faqQuestionLabel: "س.",
    faqAnswerLabel: "ج.",
    firstName: "الاسم الأول",
    middleName: "الاسم الأوسط",
    lastName: "اسم العائلة",
    phoneNumber: "رقم الهاتف",
    emailRequired: "البريد الإلكتروني",
    enterPhoneNumber: "أدخل رقم الهاتف",
    enterEmailAddress: "أدخل عنوان البريد الإلكتروني",
    searchCountryOrCode: "البحث عن البلد أو الرمز...",
    selectCountry: "اختر البلد",
    hello: "مرحباً!",
    detailsDescription: "وجدنا بياناتك في سجلاتنا، يرجى التأكيد قبل البدء",
    fetchError: "فشل تحميل تفاصيل الملف الشخصي. يرجى المحاولة مرة أخرى.",
    myProfile: "ملفي الشخصي",
    appLanguage: "لغة التطبيق",
    personalDetails: "التفاصيل الشخصية",
    loanDetails: "تفاصيل القرض",
    loanDetailsSubtitle: "رقم الطلب، مبلغ القرض المعتمد",
    applicationNumber: "رقم الطلب",
    sanctionedLoanAmount: "مبلغ القرض المعتمد",
    loginEmailId: "البريد الإلكتروني لتسجيل الدخول",
    loginEmailCannotBeChanged: "لا يمكن تغيير هذا البريد الإلكتروني",
    communicationEmailId: "البريد الإلكتروني للتواصل",
    communicationEmailDescription:
      "ستصلك جميع الرسائل والإشعارات من بلووم على عنوان البريد الإلكتروني هذا",
    phoneNumberEmail: "رقم الهاتف، البريد الإلكتروني",
    customerId: "رقم العميل",
    adhaApplication: "طلب ADHA",
    idProofs: "إثباتات الهوية",
    emiratesIdAndPassport: "الهوية الإماراتية والجواز",
    and: " و ",
    passport: "جواز السفر",
    emiratesId: "الهوية الإماراتية",
    view: "عرض",
    update: "تحديث",
    noIdProofsAvailable: "لا توجد إثباتات هوية متاحة",
    noDocumentsAvailable: "لا توجد مستندات متاحة",
    passcodePassword: "رمز المرور، كلمة المرور",
    faq: "الأسئلة الشائعة",
    customerSupport: "دعم العملاء",
    logOut: "تسجيل الخروج",
    logoutConfirmation: "هل أنت متأكد أنك تريد تسجيل الخروج؟",
    logoutError: "تعذر تسجيل الخروج. يرجى المحاولة مرة أخرى.",
    copyApplicationNumber: "نسخ رقم الطلب",
    applicationNumberCopied: "تم نسخ رقم الطلب بنجاح.",
    applicationNumberCopyFailed: "تعذر نسخ رقم الطلب. يرجى المحاولة مرة أخرى.",
    profileLoadError:
      "تعذر تحميل معلومات ملفك الشخصي. يرجى المحاولة مرة أخرى لاحقاً.",
    personalDetailsLoadError:
      "تعذر تحميل تفاصيلك الشخصية. يرجى المحاولة مرة أخرى لاحقاً.",
    personalDetailsNetworkError:
      "تعذر تحميل تفاصيلك الشخصية. يرجى التحقق من اتصالك والمحاولة مرة أخرى.",
    loanDetailsLoadError:
      "تعذر تحميل تفاصيل القرض. يرجى المحاولة مرة أخرى لاحقاً.",
    loanDetailsNetworkError:
      "تعذر تحميل تفاصيل القرض. يرجى التحقق من اتصالك والمحاولة مرة أخرى.",
    loanDetailsInvalid: "تعذر عرض تفاصيل القرض. يرجى المحاولة مرة أخرى لاحقاً.",
    loggedOutSuccessfully: "تم تسجيل\nالخروج بنجاح",
    goToLogin: "الانتقال إلى تسجيل الدخول",
    accountSecurity: "إعدادات الحساب والأمان",
    // Profile: Privacy & Security (flattened - no nested namespaces)
    privacyTitle: "الخصوصية والأمان",
    privacyPasscodeSection: "رمز المرور",
    privacyPasscode: "رمز المرور",
    privacyLoginSection: "تسجيل الدخول",
    privacyChangePassword: "تغيير كلمة المرور",
    changePasswordDescription: "انقر هنا لتغيير كلمة مرور حسابك",
    deactivate: "حذف",
    deactivateDescription:
      "حذف حسابك سيؤدي إلى تعطيل الوصول إلى التطبيق. يمكنك طلب إعادة تفعيل الحساب من خلال خدمة العملاء.",
    deactivateConfirmationTitle: "هل أنت متأكد أنك تريد حذف الحساب؟",
    deactivateAccount: "حذف الحساب",
    // Passcode keys (flattened under profile)
    passcodeEnterPasscode: "أدخل رمز المرور",
    passcodeConfirmPasscode: "تأكيد رمز المرور",
    passcodeEnterOldPasscode: "أدخل رمز المرور القديم",
    passcodeEnterNewPasscode: "أدخل رمز المرور الجديد",
    passcodeEnableBiometric: "تفعيل المصادقة البيومترية",
    passcodeSkipPasscode: "تخطي رمز المرور",
    passcodeResetPasscode: "إعادة تعيين رمز المرور",
    passcodeResetConfirmation:
      "هل أنت متأكد أنك تريد إعادة تعيين رمز المرور؟ سيتم تسجيل خروجك وسيتعين عليك تسجيل الدخول وإعداده مرة أخرى.",
    passcodeResetSuccess: "تم إعادة تعيين رمز المرور بنجاح.",
    passcodeResetError:
      "فشل في إعادة تعيين رمز المرور. يرجى المحاولة مرة أخرى.",
    passcodeSetSuccess: "تم تعيين رمز المرور بنجاح",
    passcodeChangeSuccess: "تم تغيير رمز المرور بنجاح",
    passcodeSkipSuccess: "تم تخطي إعداد رمز المرور",
    passcodeSetError: "فشل في تعيين رمز المرور. يرجى المحاولة مرة أخرى.",
    passcodeVerifyError: "فشل في التحقق من رمز المرور. يرجى المحاولة مرة أخرى.",
    passcodeChangeError: "فشل في تغيير رمز المرور. يرجى المحاولة مرة أخرى.",
    passcodeSkipError: "فشل في تخطي رمز المرور. يرجى المحاولة مرة أخرى.",
    passcodeMismatch: "رموز المرور غير متطابقة. يرجى المحاولة مرة أخرى.",
    passcodeOldInvalid: "رمز المرور القديم غير صحيح. يرجى المحاولة مرة أخرى.",
    passcodeRemoveConfirmation: "هل أنت متأكد أنك تريد إزالة رمز المرور",
    passcodeRemovedTitle: "تمت إزالة رمز المرور.",
    passcodeRemovedMessage: "يمكنك دائماً تعيينه مرة أخرى في أي وقت.",
    privacyChangePasscode: "تغيير رمز المرور",
    privacyEnableBiometric: "تفعيل المصادقة البيومترية",
    privacyRemoveBiometric: "إزالة المصادقة البيومترية",
    biometricRemoveConfirmation:
      "هل أنت متأكد أنك تريد إزالة المصادقة البيومترية",
    biometricRemovedTitle: "تمت إزالة المصادقة البيومترية.",
    biometricRemovedMessage: "يمكنك دائماً تفعيلها مرة أخرى في أي وقت.",
    biometricEnabledTitle: "تم تفعيل المصادقة البيومترية.",
    biometricEnabledMessage: "يمكنك استخدام المصادقة البيومترية لفتح التطبيق.",
  },
  registration: {
    hello: "مرحباً!",
    detailsDescription: "نحتاج فقط إلى بعض التفاصيل لنبدأ معك",
    firstName: "الاسم الأول",
    middleName: "الاسم الأوسط",
    lastName: "اسم العائلة",
    termsPrefix: "بالمتابعة فإنك توافق على ",
    termsLink: "الشروط والأحكام",
    andText: "وتقر بأنك قرأت",
    privacyLink: "سياسة الخصوصية الخاصة بنا",
    enterValidEmail: "يرجى إدخال بريد إلكتروني صالح",
    emiratesIdNumber: "رقم الهوية الإماراتية",
    passportNumber: "رقم جواز السفر",
    email: "البريد الإلكتروني",
    nationality: "الجنسية",
    selectNationality: "اختر الجنسية",
    searchNationality: "البحث عن الجنسية",
    enterHere: "أدخل هنا",
    phoneNumber: "رقم الهاتف",
    enterPhoneNumber: "أدخل رقم الهاتف",
    alreadyRegistered: "أنت مسجل بالفعل. يرجى تسجيل الدخول للمتابعة.",
    registrationCannotBeProcessed:
      "لا يمكن معالجة التسجيل في الوقت الحالي. يرجى التحقق من صحة البيانات المُدخلة.",
  },
  documentCapture: {
    title: "التقط صورة لجواز سفرك",
    subtitle: "",
    instructions: "استخدم الهوية الإماراتية الأصلية فقط",
    captureButton: "التقاط",
    flashOn: "تشغيل الفلاش",
    flashOff: "إيقاف الفلاش",
    retakePhoto: "إعادة التقاط الصورة",
    usePhoto: "استخدام الصورة",
    goodLighting: "التقط الصورة في إضاءة جيدة",
    clearDetails: "تأكد من وضوح التفاصيل",
    scanning: "جاري المسح...",
    scanningInProgress: "جاري مسح الوثيقة، يرجى الثبات",
    documentDetected: "تم اكتشاف الوثيقة",
    positionDocument: "ضع وثيقتك داخل الإطار",
    scanError: "خطأ في المسح",
    scanErrorMessage: "فشل في مسح الوثيقة. يرجى المحاولة مرة أخرى.",
    scanSuccess: "تم مسح الوثيقة بنجاح",
    autoCapture: "التقاط تلقائي",
    manualCapture: "التقاط يدوي",
    documentNotDetected: "لم يتم اكتشاف الوثيقة",
    holdSteady: "اثبت أثناء المسح",
    passportDetected: "تم اكتشاف جواز السفر! اثبت...",
    placePassportInFrame: "ضع جواز السفر داخل الإطار",
    placePassportHere: "ضع جواز سفرك هنا",
    confidence: "الثقة",
    validationFailed: "فشل التحقق",
    captureFailed: "فشل الالتقاط. يرجى المحاولة مرة أخرى.",
    scanFailed: "فشل المسح. يرجى المحاولة مرة أخرى.",
    scannerNotAvailable: "الماسح الضوئي غير متوفر على هذا الجهاز.",
    instruction1: "ضع جواز سفرك داخل الإطار",
    instruction2: "تأكد من الإضاءة الجيدة والرؤية الواضحة",
    instruction3: "اثبت عند اكتشاف جواز السفر",
    placePassport: "ضع جواز سفرك هنا",
    tapToScan: "اضغط لمسح وثيقتك",
    scanDocument: "مسح الوثيقة",
    titleEmiratesIdFront: "التقط صورة للوجه الأمامي من هويتك الإماراتية",
    titleEmiratesIdBack: "التقط صورة للوجه الخلفي من هويتك الإماراتية",
    titlePassport: "التقط صورة لجواز سفرك",
    instructionUseOriginalEmiratesId: "استخدم الهوية الإماراتية الأصلية فقط",
    instructionUseOriginalPassport: "استخدم جواز السفر الأصلي فقط",
    instructionGoodLighting: "التقط الصورة في إضاءة جيدة",
    instructionClearDetails: "تأكد من وضوح التفاصيل",
    cameraPermissionRequired: "إذن الكاميرا مطلوب",
    cameraPermissionMessage: "يرجى منح إذن الكاميرا لمسح الوثائق",
    grantPermission: "منح الإذن",
    cameraNotAvailable: "الكاميرا غير متاحة",
  },

  documentViewer: {
    clear: "مسح",
    passport: "جواز السفر",
    previewTitlePassport: "صورة جواز السفر",
    previewTitleEmiratesId: "صورة بطاقة الهوية الإماراتية",
    uploadTitle: "رفع الهوية الإماراتية",
    uploadSubtitle: "التقط صورة لهويتك الإماراتية للتحقق من هويتك",
    uploadTitlePassport: "رفع جواز السفر",
    uploadSubtitlePassport: "التقط صورة لجواز سفرك للتحقق من هويتك",
    note: "ملاحظة",
    noteText:
      "استخدم الهوية الإماراتية الأصلية فقط. التقط الصورة في إضاءة جيدة. تأكد من وضوح التفاصيل.",
    noteTextPassport:
      "استخدم جواز السفر الأصلي فقط. التقط الصورة في إضاءة جيدة. تأكد من وضوح التفاصيل.",
    front: "الوجه الأمامي",
    back: "الوجه الخلفي",
    frontSide: "الوجه الأمامي",
    backSide: "الوجه الخلفي",
    passportSide: "جواز السفر",
    capture: "التقاط",
    edit: "تعديل",
    uploading: "جاري الرفع...",
    uploaded: "تم الرفع",
    uploadError: "فشل الرفع",
  },

  documentReview: {
    title: "أوشكت على الانتهاء. يرجى تأكيد تفاصيلك",
    firstName: "الاسم الأول",
    middleName: "الاسم الأوسط",
    lastName: "اسم العائلة",
    email: "البريد الإلكتروني",
    phoneNumber: "رقم الهاتف",
    emiratesIdNumber: "رقم الهوية الإماراتية",
    emiratesIdPicture: "الهوية الإماراتية (صورة)",
    passportNumber: "رقم جواز السفر",
    passportPicture: "جواز السفر (صورة)",
    preview: "معاينة",
    submit: "إرسال",
  },

  dialogs: {
    editPhoneConfirmation: "هل أنت متأكد من أنك تريد تعديل رقم هاتفك؟",
    editEmailConfirmation:
      "سيتم استخدام هذا البريد الإلكتروني لتسجيل الدخول إلى التطبيق، هل أنت متأكد من أنك تريد تغييره؟",
    changePhoneConfirmation: "هل أنت متأكد من أنك تريد تغيير رقم هاتفك؟",
    changeEmailConfirmation:
      "هل أنت متأكد من أنك تريد تغيير عنوان بريدك الإلكتروني؟",
    yes: "نعم",
    no: "لا",
  },
  errors: {
    networkError:
      "لا يوجد اتصال بالإنترنت. يرجى التحقق من الشبكة والمحاولة مرة أخرى.",
    serverError: "خطأ في الخادم. يرجى المحاولة لاحقاً.",
    validationError: "يرجى التحقق من المدخلات والمحاولة مرة أخرى.",
    unknownError: "حدث خطأ غير معروف.",
    fillAllFields: "يرجى ملء جميع الحقول",
    loginFailed: "فشل تسجيل الدخول. يرجى المحاولة مرة أخرى.",
    registrationFailed: "فشل التسجيل. يرجى المحاولة مرة أخرى.",
    pageNotFound: "الصفحة غير موجودة",
    pageNotFoundDescription:
      "الصفحة التي تبحث عنها غير موجودة، ربما تم نقلها، أو قد يكون الرابط غير صحيح.",
    backToHome: "العودة إلى الرئيسية",
  },

  home: {
    goodMorning: "صباح الخير",
    goodAfternoon: "مساء الخير",
    goodEvening: "مساء الخير",
    goodNight: "تصبح على خير،",
    totalProperties: "إجمالي العقارات",
    purchasePrice: "سعر الشراء",
    missedPayments: "المدفوعات المتأخرة",
    paymentsDueIn30Days: "المدفوعات المستحقة خلال 30 يوم",
    paymentUpdates: "تحديثات المدفوعات",
    bloomVentures: "مشاريع بلوم",
    inProcess: "قيد المعالجة",
    paymentConfirmed: "تم تأكيد الدفع",
    hello: "مرحباً",
    exclusiveListingsForYou: "عروض حصرية لك",
    tabLabel: "الرئيسية",
    paidOn: "دفع في",
  },

  payments: {
    tabLabel: "الدفعات",
    title: "الدفعات",
    propertyPayments: "مدفوعات العقارات",
    serviceChargePayments: "مدفوعات رسوم الخدمة",
    property: "عقار",
    properties: "عقارات",
    cheque: "شيك",
    cheques: "شيكات",
    chequesAvailable: "الشيكات المتاحة",
    lastPayment: "آخر دفعة",
    upcoming: "القادمة",
    inProcessPayments: "المعالجة",
    statusPaid: "مدفوع",
    statusDueSoon: "مستحق قريباً",
    payViaBankToBloom: "يمكنك الدفع عبر البنك إلى بلوم",
    history: "السجل",
    allProperties: "جميع العقارات",
    propertiesSelected: "عقارات محددة",
    selectProperties: "اختر العقارات",
    searchPropertiesPlaceholder: "اكتب اسم العقار/اسم المشروع",
    save: "حفظ",
    filter: "تصفية",
    missedPayments: "مدفوعات فائتة",
    dueIn30Days: "مستحقة خلال 30 يوم",
    totalOutstanding: "إجمالي المستحقات",
    dueSoonPayments: "مدفوعات مستحقة قريباً",
    futurePayments: "دفعات مستقبلية",
    noPaymentHistory: "لا يوجد سجل مدفوعات متاح",
    total: "المجموع",
    paymentSelected: "دفعة محددة",
    paymentsSelected: "مدفوعات محددة",
    excludingTaxes: "باستثناء الضرائب",
    cancel: "إلغاء",
    paymentSummary: "ملخص الدفع",
    paymentBreakdown: "تفصيل الدفع",
    feesAndCharges: "الرسوم والرسوم الإضافية",
    latePaymentFee: "رسوم الدفع المتأخر",
    convenienceFee: "رسوم التكنولوجيا",
    excludingCardProcessingFee: "باستثناء رسوم معالجة البطاقة",
    cardProcessingFee: "رسوم معالجة البطاقة",
    estimatedCardProcessingFee: "رسوم معالجة البطاقة المقدرة",
    domesticCards: "البطاقات المحلية",
    internationalCards: "البطاقات الدولية",
    termsAndConditions: "الشروط والأحكام",
    pay: "ادفع",
    septemberInstalment: "قسط سبتمبر",
    octoberInstalment: "قسط أكتوبر",
    dueBy: "مستحق بتاريخ",
    supportButtonPressed: "تم الضغط على زر الدعم",
    payNowPressed: "تم الضغط على ادفع الآن",
    termsPressed: "تم الضغط على الشروط والأحكام",
    paymentFailedTitle: "فشل في الدفع",
    paymentFailedDescription:
      "لا يمكننا معالجة دفعتك. يرجى إعادة المحاولة أو المحاولة بعد بعض الوقت.",
    paymentTemporaryIssue:
      "لا يمكننا معالجة دفعتك ({{paymentNames}}) بسبب مشكلة مؤقتة. يرجى المحاولة مرة أخرى لاحقًا.",
    paymentErrorCode: "خطأ: D61-راجع مصدر البطاقة",
    paymentCancelledTitle: "تم إلغاء الدفع",
    paymentCancelledDescription:
      "لقد ألغيت الدفع. يمكنك المحاولة مرة أخرى عندما تكون مستعداً.",
    paymentSuccessTitle: "تم الدفع بنجاح",
    paymentSuccessDescription:
      "سيتم إنشاء الإيصال بعد معالجة الدفعة. قد يستغرق هذا ما يصل إلى 5 أيام عمل.",
    paymentPendingTitle: "جاري معالجة دفعتك",
    transactionId: "رقم المعاملة",
    transactionIdCopied: "تم نسخ رقم المعاملة",
    chequeNotice:
      "هذه العقار لديه شيكات في انتظار المقاصة. لجمع أو تمزيق الشيكات، يرجى الاتصال بدعم العملاء",
    raiseChequeShredRequest: "رفع طلب تمزيق الشيك",
    raiseChequeShredRequestPressed: "تم الضغط على رفع طلب تمزيق الشيك",
    paymentDetails: "تفاصيل الدفع",
    autoDeductionNotice: "سيتم خصم الدفعة تلقائياً عبر الشيك الموجود في الملف",
    receiptGenerationNotice:
      "سيتم إنشاء الإيصال بعد معالجة الدفعة. قد يستغرق هذا ما يصل إلى 5 أيام عمل.",
    proFormaInvoiceQuestion: "هل تريد فاتورة أولية؟",
    installmentNumber: "القسط رقم #{number}",
    viewReceipt: "عرض الإيصال",
    downloadInvoice: "تحميل",
    percentOfTotalAmount: "% من المبلغ الإجمالي",
    onlinePaymentFeeNotice:
      "الدفع عبر الإنترنت سيؤدي إلى فرض رسوم سحب/إلغاء الشيك",
    paymentNotFound: "لم يتم العثور على الدفعة",
    type: "النوع",
    dueDate: "تاريخ الاستحقاق",
    raiseRequest: "رفع طلب",
    payNow: "ادفع الآن",
    viewBankDetails: "عرض تفاصيل البنك",
    totalAmount: "المبلغ الإجمالي",
    paidAmount: "المبلغ المدفوع",
    remainingAmount: "المبلغ المتبقي",
    reportIssue: "الإبلاغ عن مشكلة",
    retry: "إعادة المحاولة",
    tryAgain: "حاول مرة أخرى",
    checkingPaymentStatus: "جارٍ التحقق من حالة الدفع...",
    pendingPaymentNotification: "سنخطرك بمجرد معالجة دفعتك.",
    backToHome: "العودة إلى الرئيسية",
    retryPressed: "تم الضغط على إعادة المحاولة",
    tryAgainPressed: "تم الضغط على زر المحاولة مرة أخرى",
    reportIssuePressed: "تم الضغط على الإبلاغ عن مشكلة",
    paymentCheckout: "دفع الدفع",
    redirectingToPayment: "إعادة التوجيه إلى بوابة الدفع...",
    noPaymentsSelected: "لم يتم تحديد مدفوعات",
    noUpcomingPayments: "لا توجد مدفوعات {type} قادمة",
    emptyStateTitleProperty: "لقد انتهيت من جميع مدفوعات العقار!",
    emptyStateTitleCommunity: "لقد انتهيت من جميع مدفوعات المجتمع!",
    emptyStateSubtitle: "لا توجد أي مدفوعات مستحقة حالياً.",
    historyEmptyStateTitle: "عذراً! يبدو فارغاً",
    historyEmptyStateSubtitle: "يرجى إجراء الدفع من خلال التطبيق لعرض السجل.",
    accountStatement: "كشف الحساب",
  },
  properties: {
    tabLabel: "عقاراتي",
    myProperties: "عقاراتي",
    constructionCompleted: "تم البناء",
    installmentPaid: "القسط المدفوع",
    subtitle: "إليك وصول سريع لعقاراتك ومدفوعاتك والمزيد.",
    hello: "مرحباً",
    noPropertiesFound: "لا توجد عقارات",
    noPropertiesYetTitle: "لا توجد عقارات بعد",
    noPropertiesYetSubtitle: "لا توجد عقارات لعرضها حاليًا.",
    missedPayment: "دفعات متأخرة",
    missedPayments: "مدفوعات فائتة",
    paymentDueSoon: "{count} مدفوع مستحقة خلال 30 يوماً",
    paymentsDueSoon: "{count} مدفوعات مستحقة خلال 30 يوماً",
    noPendingDues: "لا مستحقات متبقية",
    priceRange: "نطاق السعر",
    loanAmount: "(مبلغ القرض الخاص بك)",
    millionAbbrev: "م",
    sqFt: "قدم مربع",
    loanEligibility: "اختيارك {{loanStatus}} أهلية قرضك.",
    above: "أعلى من",
    within: "ضمن",
    availableLoanAmountNote: "مبلغ قرض الإسكان المتاح لك هو {{loanAmount}}.",
    selectCategory: "اختر الفئة",
    applyFilter: "تطبيق الفلتر",
    projectDetails: "تفاصيل المشروع",
  },
  propertyDetails: {
    title: "تفاصيل العقار",
    unitDetails: "تفاصيل الوحدة",
    aboutUnit: "حول الوحدة",
    unitInfo: "معلومات الوحدة",
    yourFabPreApproval: "موافقة FAB المسبقة الخاصة بك",
    fabPreApprovalCoversUnit: "تغطي هذه الوحدة",
    brochure: "بروشور",
    masterPlan: "المخطط الرئيسي",
    discoverMasterPlan: "اكتشف المخطط الرئيسي لـ {{projectName}}",
    view: "عرض",
    brochureNotAvailable: "البروشور غير متاح لهذا العقار.",
    brochureDownloadFailed: "فشل تنزيل البروشور. يرجى المحاولة مرة أخرى.",
    documentSaveFailed: "فشل حفظ الملف. يرجى المحاولة مرة أخرى.",
    customerIdNotAvailable: "معرّف العميل غير متاح.",
    imInterested: "أنا مهتم",
    totalPrice: "السعر الإجمالي",
    noPropertyData: "لا توجد بيانات العقار متاحة",
    addressingNumber: "رقم العنوان",
    addressingNumberCopied: "تم نسخ رقم العنوان",
    failedToCopy: "فشل النسخ",
    spaAvailable: "اتفاقية البيع والشراء متاحة للتنزيل من المستندات",
    paymentCompleted: "اكتمال الدفع",
    amountOutstanding: "المبلغ المستحق",
    chequeAvailable: "شيك متاح",
    chequeAvailableDescription: "لديك شيكات ضد هذا العقار. ارفع طلباً لتقطيعها",
    raiseRequest: "رفع طلب",
    aboutProperty: "حول العقار",
    propertyInfo: "تفاصيل العقار",
    bedrooms: "غرف النوم",
    bathrooms: "الحمامات",
    areaInSqFt: "المساحة بالقدم المربع",
    viewFloorPlan: "عرض مخطط الطابق",
    amenities: "الخدمات",
    documents: "المستندات",
    documentsAvailable: "{count} مستند متاح",
    fileDownloadedWithName: "تم تنزيل الملف بنجاح: {{fileName}}",
    folderSelectionCancelled: "تم إلغاء اختيار المجلد. يرجى اختيار مجلد (مثل التنزيلات) لحفظ الملف.",
    iosNoWritableDirectory: "لا يتوفر مجلد قابل للكتابة على نظام iOS.",
    iosSaveHint: 'على iOS، اضغط مشاركة واختر "حفظ في الملفات" لاختيار مجلد.',
    documentsListTitleDeed: "سند الملكية",
    documentsListSpa: "مستند اتفاقية البيع والشراء",
    documentsListFloorPlan: "خطة الكلمة",
    documentsListPassport: "جواز السفر",
    documentsListEidFront: "هوية الإمارات (الواجهة)",
    documentsListEidBack: "هوية الإمارات (الظهر)",
    documentsListAccountStatement: "كشف الحساب",
    documentsListReceiptHistory: "سجل الإيصالات",
    ownerDetails: "تفاصيل المالك",
    share: "الحصة",
    primary: "رئيسي",
    payments: "الدفعات",
    missed: "متأخرة",
    dueIn30Days: "مستحقة خلال 30 يوماً",
    upcoming: "القادمة",
    history: "السجل",
    property: "العقار",
    community: "المجتمع",
    paymentHistory: "سجل المدفوعات",
    missedPayments: "{count} مدفوعات متأخرة",
    noPayments: "لا توجد مدفوعات {type}",
    noPaymentHistory: "لا يوجد سجل مدفوعات {type}",
    paymentsDueIn30Days: "+ {count} مدفوعات مستحقة خلال 30 يوماً",
    viewMore: "عرض المزيد",
    viewAll: "عرض الكل",
    accountStatement: "كشف الحساب",
    paySelected: "دفع المحدد",
    dueBy: "مستحق بتاريخ",
    handover: "التسليم",
    installment: "القسط",
    downPayment: "الدفعة الأولى",
    admFee: "رسوم الإدارة",
    noPaymentsSelected: "لم يتم تحديد مدفوعات",
    bhkFlat: "{bedrooms} غرف، {amenitiesCount} مرافق",
    amenitiesCount: "{count} مرافق",
    aed: "درهم",
    floorPlanUnavailableError: "العقار أو العميل غير متاح",
    floorPlanOpenError: "تعذر فتح مخطط الطابق",
    floorPlanSaveError: "فشل حفظ مخطط الطابق",
    openMapsError: "فشل فتح تطبيق الخرائط.",
    chooseNextStep: "اختر خطوتك التالية",
    bookAppointmentTitle: "حجز موعد",
    bookAppointmentDescription:
      "قم بزيارة الوحدة في الوقت المناسب لاستكشافها شخصياً ومناقشة التفاصيل مع أحد ممثلي المبيعات.",
    bookAppointmentCta: "حجز الموعد",
    appointmentBookingSuccess: "تم رفع طلب حجز الموعد بنجاح!",
    reserveUnitTitle: "حجز الوحدة",
    reserveUnitDescription:
      "احجز الوحدة المفضلة لديك لبدء عملية الحجز والاقتراب خطوة أخرى نحو التملك.",
    reserveUnitCta: "حجز الوحدة",
    viewReservationCta: "عرض الحجز",
    unitReservationSuccess: "تم رفع طلب حجز الوحدة بنجاح!",
    viewAppointmentCta: "عرض الموعد",
    appointmentConfirmedTitle: "تم تأكيد الموعد",
    date: "التاريخ",
    time: "الوقت",
    contactPersonName: "مدير الحساب",
    phoneNumber: "رقم الهاتف",
    reschedule: "إعادة الجدولة",
    cancelAppointment: "إلغاء الموعد",
    cancelAppointmentRequest: "إلغاء الطلب",
    appointmentCanceledSuccess: "تم إلغاء الموعد بنجاح.",
    handoverDateLabel: "تاريخ التسليم",
    handoverDateWithDate: "تاريخ التسليم: {date}",
    constructionCompletedPercent: "اكتمل البناء {percent}%",
    unitPriceLabel: "سعر الوحدة",
    outstandingBalance: "الرصيد المستحق",
    payNow: "ادفع الآن",
    completePaymentTitle: "أكمل عملية الدفع",
    approvedIskanLoan: "قرض الإسكان المعتمد",
    howWouldYouLikeToProceed: "كيف تود المتابعة؟",
    bankTransfer: "تحويل بنكي",
    bankTransferDescription: "ادفع مباشرة إلى الحساب الموضح",
    proofOfMortgage: "إثبات الرهن",
    proofOfMortgageDescription: "قدّم موافقة الرهن العقاري",
    bankTransferDetailsTitle: "تفاصيل التحويل البنكي",
    transferToThisAccount: "حوّل إلى هذا الحساب",
    accountName: "اسم الحساب",
    amountPaid: "المبلغ المدفوع",
    bankName: "اسم البنك",
    accountNumber: "رقم الحساب",
    iban: "IBAN",
    swiftCode: "رمز SWIFT",
    bankTransferNotePrefix: "يرجى التأكد من إرسال إثبات الدفع إلى",
    bankTransferNoteProof: "إثبات الدفع",
    bankTransferNoteEmailConnector: " إلى ",
    bankTransferNoteEmail: "",
    iveMadeTheTransfer: "لقد أتممت التحويل",
    copiedToClipboard: "تم النسخ",
    submissionReceivedTitle: "قدّم إثباتك",
    submitProofPaymentInstruction: "يرجى إرسال إثبات الدفع عبر البريد الإلكتروني إلى:",
    submitProofMortgageInstruction: "يرجى إرسال إثبات الرهن عبر البريد الإلكتروني إلى:",
    submitProofReviewNote: "سيقوم فريقنا بمراجعة الدفع وتأكيده.",
    submitProofEmail: "xyz@bloomholding.com",
    backToUnitDetails: "العودة إلى تفاصيل الوحدة",
    iskanLoanCoversTemplate: "{amount} يغطي هذه الوحدة",
    iskanLoanCoversVerb: "يغطي",
    iskanLoanCoversUnitSuffix: "هذه الوحدة",
    unitLoadError:
      "يتعذر علينا تحميل تفاصيل الوحدة في الوقت الحالي. يرجى المحاولة مرة أخرى لاحقاً.",
    documentDownloadFailed: "تعذر تنزيل المستند. يرجى المحاولة مرة أخرى.",
  },
  reserveUnit: {
    confirmTitle: "تأكيد حجزك",
    confirmSubtitle:
      "راجع التفاصيل أدناه لحجز هذه الوحدة. بعد الإرسال، سيتم إرسال نموذج الحجز إليك عبر البريد الإلكتروني.",
    totalUnitPrice: "السعر الإجمالي للوحدة",
    iskanLoan: "قرض إسكان",
    remainingBalance: "الرصيد المتبقي",
    importantToNote: "ملاحظة هامة",
    importantNoteBody:
      "سعر الوحدة يتجاوز تغطية القرض المعتمد لديك. يجب دفع الرصيد المتبقي بشكل منفصل.",
    whatHappensNext: "ماذا يحدث بعد ذلك؟",
    stepEmail: "ستتلقى نموذج حجز لتوقيعه عبر البريد الإلكتروني",
    stepDeadline: "وقع نموذج الحجز خلال 15 يومًا للحفاظ على حجزك نشطًا.",
    proceedCta: "المتابعة للحجز",
    unitReservedTitle: "تم حجز الوحدة",
    unitReservedCongrats: "تهانينا!",
    unitReservedMessage:
      "تم حجز وحدتك. أنت الآن أقرب خطوة نحو التملك. سيتم مشاركة نموذج الحجز عبر البريد الإلكتروني قريبًا.",
    pendingBadge: "قيد الانتظار",
    awaitingSignatureNote: "في انتظار التوقيع",
    reservationSummaryTitle: "ملخص الحجز",
    requestedOn: "تاريخ الطلب",
    status: "الحالة",
    resendEmailNote:
      "لم تستلم البريد الإلكتروني؟ يرجى التحقق من مجلد الرسائل غير المرغوب فيها أو طلب بريد إلكتروني جديد.",
    cancelReservation: "إلغاء الحجز",
    cancelReservationConfirmMessage: "هل أنت متأكد أنك تريد إلغاء حجزك؟",
    resendEmail: "إعادة إرسال البريد",
    emailResentSuccess: "تم إعادة إرسال البريد الإلكتروني بنجاح!",
    reservationCanceledSuccess: "تم إلغاء الحجز بنجاح.",
    reservationCanceledTitle: "تم إلغاء الحجز",
    reservationCanceledMessage: "تم إلغاء حجزك بنجاح.",
    unitAlreadyReservedError:
      "هذه الوحدة لم تعد متاحة. يرجى تصفح الوحدات المتاحة الأخرى.",
    submissionFailedError:
      "يتعذر علينا معالجة حجزك في الوقت الحالي. يرجى المحاولة مرة أخرى لاحقًا.",
    resendEmailError:
      "يتعذر علينا إعادة إرسال البريد الإلكتروني الآن. يرجى المحاولة مرة أخرى لاحقًا.",
    cancelReservationError:
      "يتعذر علينا إلغاء حجزك في الوقت الحالي. يرجى المحاولة مرة أخرى لاحقًا.",
    reservationPending: "الحجز قيد الانتظار",
    reservationInProgress: "الحجز قيد التنفيذ",
    reservationConfirmed: "تم تأكيد الحجز",
    checkEmailTitle: "تحقق من بريدك الإلكتروني",
    reservedBannerTitle: "محجوز!",
    proceedShortfallCta: "متابعة",
    activeReservationToast:
      "لديك حجز نشط بالفعل. يمكنك إلغاء حجزك السابق والحجز مرة أخرى لأنه يمكن حجز وحدة ADHA واحدة فقط في كل مرة.",
    activeReservationListingToast:
      "لديك حجز نشط بالفعل. يمكنك حجز عقار ADHA واحد فقط.",
    reservationStatus: {
      customerSignedBookingForm: "تم توقيع نموذج الحجز",
      opportunityNotCreated: "تم إرسال نموذج الحجز",
      opportunityCreated: "تم إرسال نموذج الحجز",
      awaitingReservationFormCustomer: "تم إرسال نموذج الحجز",
      awaitingReservationFormBloom: "تم إرسال نموذج الحجز",
      reservationFormSigned: "تم توقيع نموذج الحجز",
      decreeApproval: "تم إرسال نموذج الحجز",
      spaAwaitingCustomer: "في انتظار توقيع اتفاقية البيع والشراء",
      spaAwaitingBloom: "في انتظار توقيع بلوم لاتفاقية البيع والشراء",
      spaSigned: "تم توقيع اتفاقية البيع والشراء",
      unknownReserved: "تم إرسال نموذج الحجز",
    },
    reservationVisible: {
      inProgressListing: "قيد التنفيذ",
      processingApplication: "تم إرسال نموذج الحجز",
      awaitingYourSignature: "في انتظار التوقيع",
      awaitingBloomHoldingSignature:
        "في انتظار توقيع بلوم لاتفاقية البيع والشراء",
      reservationConfirmedListing: "تم تأكيد الحجز",
      bookAppointmentToContinue: "تم توقيع نموذج الحجز",
      reservationFormSent: "تم إرسال نموذج الحجز",
      reservationFormSigned: "تم توقيع نموذج الحجز",
      awaitingSpaSignature: "في انتظار توقيع اتفاقية البيع والشراء",
      awaitingBloomSpaSignature: "في انتظار توقيع بلوم لاتفاقية البيع والشراء",
      spaSigned: "تم توقيع اتفاقية البيع والشراء",
      bookingFormSigned: "تم توقيع نموذج الحجز",
    },
  },
  bookAppointment: {
    title: "حجز موعد",
    slotDate: "تاريخ الموعد",
    slotTime: "اختر الفترة الزمنية",
    slotSubtitle: "اختر تاريخاً ووقتاً مناسبين لزيارة مكتب بلوم.",
    today: "اليوم",
    tomorrow: "غداً",
    bookAppointment: "حجز الموعد",
    reschedule: "إعادة جدولة الموعد",
    requestRaised: "تم تقديم طلب حجز الموعد بنجاح!",
    upcomingAppointment: "الموعد القادم",
    visitOffice: "زيارة المكتب",
    joinHere: "انضم عبر الإنترنت",
    cancelMessage: "هل أنت متأكد أنك تريد إلغاء موعدك؟",
    canceledTitle: "تم إلغاء الموعد",
    canceledMessage: "تم إلغاء موعدك بنجاح.",
    slotsEmpty: "لا توجد فترات متاحة !",
    slotsError: "تعذر تحميل الفترات الزمنية. يرجى المحاولة مرة أخرى.",
    slotsNoneAvailable:
      "لا توجد مواعيد متاحة حالياً. يرجى المحاولة مرة أخرى لاحقاً.",
    slotNoLongerAvailable:
      "لم يعد هذا الموعد متاحاً. يرجى اختيار موعد آخر متاح.",
    bookError:
      "يتعذر علينا حجز موعدك في الوقت الحالي. يرجى المحاولة مرة أخرى لاحقاً.",
    rescheduleError:
      "يتعذر علينا إعادة جدولة موعدك في الوقت الحالي. يرجى المحاولة مرة أخرى لاحقاً.",
    cancelError:
      "يتعذر علينا إلغاء موعدك في الوقت الحالي. يرجى المحاولة مرة أخرى لاحقاً.",
  },
  notifications: {
    title: "الإشعارات",
    upToDate: "أنت محدث!",
    count: "الإشعارات",
    clearAll: "مسح الكل",
  },
  support: {
    title: "الدعم",
    subtitle: "مرحباً {{name}} كيف يمكنني مساعدتك؟",
    raiseRequest: "تقديم طلب",
    history: "السجل",
    createTitle: "أخبرنا بمشكلتك",
    createSubtitle: "مرحباً {{name}} كيف يمكنني مساعدتك؟",
    selectUnitLabel: "اختر الوحدة",
    selectUnitPlaceholder: "اختر وحدتك",
    selectCategoryLabel: "اختر الفئة",
    selectCategoryPlaceholder: "اختر فئة",
    describeIssueLabel: "صف مشكلتك",
    describeIssuePlaceholder: "صف مشكلتك هنا",
    submitRequestCta: "إرسال الطلب",
    requestCallbackCta: "طلب معاودة الاتصال",
    emailLabel: "البريد الإلكتروني",
    emailPlaceholder: "أدخل بريدك الإلكتروني",
    phoneLabel: "رقم الهاتف",
    phonePlaceholder: "أدخل رقم هاتفك",
    countryCodePlaceholder: "رمز",
    successTitle: "تم إرسال الطلب",
    successSubtitle: "استلمنا طلبك وسنتواصل معك قريباً.",
    guestNameFallback: "ضيفنا",
    errorSelectUnit: "يرجى اختيار وحدة",
    errorSelectCategory: "يرجى اختيار فئة",
    errorDescribeIssue: "يرجى وصف مشكلتك",
    errorEmail: "يرجى إدخال بريد إلكتروني صالح",
    errorPhone: "يرجى إدخال رقم هاتفك",
    inProgress: "قيد التنفيذ",
    resolved: "تم الحل",
    emptyState: "لا توجد طلبات خدمة",
    // Details (flattened)
    detailsTitle: "تفاصيل المشكلة",
    detailsUnit: "الوحدة",
    detailsCategory: "الفئة",
    detailsSubCategory: "الفئة الفرعية",
    detailsIssueDescription: "وصف المشكلة",
    detailsStatus: "الحالة",
    detailsCaseNumber: "رقم الحالة",
    detailsCreatedOn: "تاريخ الإنشاء",
    detailsDescription: "الوصف",
    detailsNoDescription: "لا يوجد وصف",
    detailsUpdates: "التحديثات",
    detailsNoUpdates: "لا توجد تحديثات بعد",
    detailsContactSupport: "الاتصال بالدعم",
    detailsUpdateTeamContacted: "تواصل فريق بلوم معك",
    detailsUpdateInProgress: "دعم العملاء يراجع المشكلة",
    detailsUpdateRaised: "تم إنشاء الطلب",
  },
  propertiesWeb: {
    title: "العقارات",
    list: {
      greetingPrefix: "صباح الخير",
      millionAbbrev: "م",
      oneMillion: "1 م",
      twoMillion: "2 م",
      threeMillion: "3 م",
      sixMillion: "6 م",
      emptyNoProperties:
        "لا توجد عقارات ADHA متاحة حالياً. يرجى المحاولة مرة أخرى لاحقاً.",
      emptyFilterNoMatch:
        "لم يتم العثور على عقارات ضمن نطاق السعر وعوامل التصفية المحددة. يرجى تعديل عوامل التصفية لعرض المزيد من الخيارات.",
      emptyFetchError:
        "يتعذر علينا تحميل قوائم العقارات في الوقت الحالي. يرجى المحاولة مرة أخرى لاحقاً.",
      projectDetailsTab: "تفاصيل المشروع",
      exploreUnitsTab: "استكشف الوحدات",
      exploreUnitsTitle: "استكشف الوحدات",
      associatedUnits: "الوحدات المرتبطة",
      filters: {
        openFilters: "فتح عوامل التصفية",
        title: "عوامل التصفية",
        close: "إغلاق عوامل التصفية",
        unitNumber: "رقم الوحدة",
        unitNumberPlaceholder: "أدخل رقم الوحدة",
        matchingUnits: "الوحدات المطابقة",
        noMatchingUnits: "لا توجد وحدات تطابق هذا الرقم",
        numberOfBedrooms: "عدد غرف النوم",
        bedroomsHint: "اختر واحدة أو أكثر",
        bedroomsShort: "{{count}} غرف",
        bedroomOption: "{{count}} غرف",
        selectBedrooms: "اختر عدد غرف النوم",
        apply: "تطبيق",
        cluster: "المجموعة",
        clusterPlaceholder: "اختر المجموعة",
        clearAll: "مسح الكل",
        applyFilter: "تطبيق التصفية",
      },
    },
  },
  guestWeb: {
    unitDetails: "تفاصيل المشروع",
    breadcrumbHome: "الرئيسية",
    breadcrumbUnitDetails: "تفاصيل المشروع",
    exploreProperties: "استكشف العقارات",
    aboutProperty: "عن العقار",
    documents: "المستندات",
    brochure: "بروشور",
    numberOfUnits: "عدد الوحدات",
    unitType: "نوع الوحدة",
    amenities: "المرافق",
    login: "تسجيل الدخول",
    maybeLater: "ربما لاحقاً",
    loginPromptTitle: "تسجيل الدخول",
    loginPromptMessage: "سجّل الدخول لعرض تفاصيل العقار الكاملة.",
    emptyNoProperties:
      "لا توجد عقارات متاحة حالياً. يرجى المحاولة مرة أخرى لاحقاً.",
    emptyFetchError:
      "يتعذر علينا تحميل قوائم العقارات في الوقت الحالي. يرجى المحاولة مرة أخرى لاحقاً.",
    exploreEmpty: "لا توجد عقارات أخرى لاستكشافها حالياً.",
    unitsBadge: "{{count}} وحدات",
    greeting: "{{greeting}} !",
  },
  bloomUniversal: {
    spaceComingSoon: "صفحة مساحة بلوم هذه قادمة قريباً.",
    backToSpaces: "العودة إلى مساحات بلوم",
    breadcrumbHome: "الرئيسية",
    discoverMore: "اكتشف المزيد",
    callSupport: "اتصل بدعم بلوم",
    call: "اتصل",
    exploreEyebrow: "استكشف عالم بلوم",
    exploreBody: "اكتشف المجتمعات والتجارب والخدمات التي تشكّل الحياة اليومية.",
    exploreTitle: "استكشف عالم بلوم",
    exploreSubtitle:
      "اكتشف المجتمعات والتجارب والخدمات التي تشكّل الحياة اليومية.",
  },
  ventures: {
    website: "الموقع الإلكتروني",
    contact: "تواصل",
  },
  bloomExperience: {
    label: "تجربة بلووم",
    heroTitle: "أكثر من مجرد مكان للعيش.",
    heroSubtitle: "أسلوب حياة بلووم.",
    getStarted: "لنبدأ",
    exploreTitle: "استكشف عالم بلووم",
    exploreSubtitle:
      "اكتشف المجتمعات والتجارب والخدمات التي تشكّل الحياة اليومية.",
    facilitiesManagement: "بلووم لإدارة المرافق",
    hospitality: "بلووم للضيافة",
    properties: "بلووم العقارية",
    retail: "بلووم للتجزئة",
    education: "بلووم للتعليم",
    landscape: "بلووم لتنسيق الحدائق",
    facilitiesManagementTitle: "بلووم لإدارة المرافق",
    discoverMore: "اكتشف المزيد",
    keyInstitutions: "المؤسسات الرئيسية",
    facilitiesManagementDescription:
      "نقدم خدمات شاملة لإدارة المرافق والمجتمعات، لنحافظ على سلامة ونظافة كل مجتمع من مجتمعات بلووم.",
    hospitalityDescription:
      "نقدم تجارب ضيافة استثنائية من خلال تشغيل فنادق ووجهات ترفيهية عالمية المستوى في جميع أنحاء الإمارات.",
    propertiesDescription:
      "نصمم وننفذ مجتمعات مخططة بعناية، ونقدم مجموعة متنوعة من المنازل في أرقى وجهات أبوظبي.",
    retailDescription:
      "نبتكر وجهات تجزئة وتجارب طعام نابضة بالحياة تجمع بين الراحة والمجتمع وأسلوب الحياة.",
    educationDescription:
      "نحن مزود تعليمي رائد، نشكّل أجيال المستقبل من خلال مدارس ودور حضانة وشراكات تعليمية عالمية المستوى في جميع أنحاء الإمارات.",
    landscapeDescription:
      "ننشئ ونحافظ على مساحات خضراء مستدامة ونابضة بالحياة تُثري مجتمعات بلووم.",
  },
} as unknown as TranslationKeys;
